export default __webpack_public_path__ + "static/media/Billboard.bb797c98.svg";